/** Change Log filter options (match audit_logs writers in API). */

export const CHANGELOG_ACTION_OPTIONS = [
  { value: 'update', label: 'Update' },
  { value: 'replace', label: 'Replace' },
  { value: 'create', label: 'Create' },
  { value: 'delete', label: 'Delete' },
  { value: 'soft_delete', label: 'Soft delete' },
  { value: 'restore', label: 'Restore' },
  { value: 'purge', label: 'Purge' },
  { value: 'user.login', label: 'Login' },
  { value: 'compensation.export', label: 'Export' },
];

export const CHANGELOG_ENTITY_TYPE_OPTIONS = [
  { value: 'employee', label: 'HR profile' },
  { value: 'employee_compensation', label: 'Compensation' },
  { value: 'employee_compensation_item', label: 'Compensation items' },
  { value: 'time_off_entry', label: 'Time off' },
  { value: 'employee_emergency_contacts', label: 'Emergency contacts' },
  { value: 'employee_children', label: 'Children' },
  { value: 'employee_work_schedule', label: 'Work schedule' },
  { value: 'employee_document', label: 'Documents' },
  { value: 'user', label: 'Login' },
];

export function changelogEntityTypeLabel(entityType) {
  const match = CHANGELOG_ENTITY_TYPE_OPTIONS.find((opt) => opt.value === entityType);
  if (match) return match.label;
  if (!entityType) return '—';
  return String(entityType)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function changelogActionSeverity(action) {
  if (action === 'create' || action === 'restore' || action === 'employee_document.upload') return 'success';
  if (
    action === 'update'
    || action === 'replace'
    || action === 'employee_document.update'
    || action === 'employee_document.acknowledge'
  ) return 'info';
  if (
    action === 'delete'
    || action === 'soft_delete'
    || action === 'purge'
    || action === 'employee_document.archive'
  ) return 'danger';
  if (action === 'user.login' || action === 'compensation.export' || action === 'attendance.export') {
    return 'secondary';
  }
  return 'secondary';
}

export function hasActiveChangelogFilters(filters) {
  if (!filters) return false;
  return Boolean(
    filters.search?.trim()
    || filters.action
    || filters.entity_type
    || filters.date_from
    || filters.date_to
    || (Number(filters.employee_hr_id) > 0)
  );
}

export function changelogEmployeeOptionFromRow(row) {
  const employeeHrId = Number(row?.employee_record_id ?? row?.employee_hr_id);
  if (!Number.isInteger(employeeHrId) || employeeHrId <= 0) return null;
  const hrName = [row.first_name, row.last_name].filter(Boolean).join(' ').trim();
  const label = hrName || String(row.name || '').trim() || `Employee #${employeeHrId}`;
  return {
    value: employeeHrId,
    label,
    name: label,
    avatar_url: row.avatar_url ?? null,
    department_id: row.department_id ?? null,
    department_name: row.department_name || '',
    department_tag_color: row.department_tag_color ?? null,
    department_tag_text_color: row.department_tag_text_color ?? null,
  };
}

export function changelogTargetEmployeePerson(entry) {
  const employeeHrId = Number(entry?.target_employee_id);
  if (!Number.isInteger(employeeHrId) || employeeHrId <= 0) return null;
  const label = String(entry.target_label || '').trim() || `Employee #${employeeHrId}`;
  return {
    value: employeeHrId,
    label,
    name: label,
    avatar_url: entry.target_avatar_url ?? null,
    department_id: entry.target_department_id ?? null,
    department_name: entry.target_department_name || '',
    department_tag_color: entry.target_department_tag_color ?? null,
    department_tag_text_color: entry.target_department_tag_text_color ?? null,
  };
}

export function changelogEmployeePersonFromOption(option) {
  if (!option) return null;
  const label = String(option.label || option.name || '').trim();
  if (!label) return null;
  return {
    name: label,
    label,
    avatar_url: option.avatar_url ?? null,
    department_id: option.department_id ?? null,
    department_name: option.department_name || '',
    department_tag_color: option.department_tag_color ?? null,
    department_tag_text_color: option.department_tag_text_color ?? null,
  };
}
